// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  enabled: __t.bool(),
  minReplicas: __t.u32().name("min_replicas"),
  maxReplicas: __t.u32().name("max_replicas"),
  jobsPerReplica: __t.u32().name("jobs_per_replica"),
  scaleDownDelaySeconds: __t.u32().name("scale_down_delay_seconds"),
  replicas: __t.u32(),
  desired: __t.u32(),
  error: __t.string(),
  lastScaledAt: __t.option(__t.timestamp()).name("last_scaled_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
